import Fetch from "utils/fetch";

export const obterComposicao = (numeroPedido) => {
    return Fetch.get(`/pedido/composicaoPedido/${numeroPedido}`).then(({ data }) => data);
}

export const obterPedidosComposicao = (numeroPedido) => {
    return Fetch.get(`/pedido/pedidosComposicao/${numeroPedido}`).then(({ data }) => data);
}